var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgL2Tvbh = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 37C10.6111 37 3 29.3889 3 20C3 10.6112 10.6111 3 19.9999 3C29.3888 3 37 10.6112 37 20C37 22.7195 36.3614 25.2898 35.2261 27.5692C34.9243 28.175 34.824 28.8673 34.9989 29.521L36.0114 33.3053C36.4509 34.948 34.948 36.451 33.3053 36.0114L29.521 34.9989C28.8673 34.824 28.1748 34.9244 27.5691 35.2261C25.2898 36.3615 22.7194 37 19.9999 37Z",
    fill: "url(#paint0_linear_2101_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.4391C11 21.9588 14.6174 24.3674 17.2656 26.523C18.2 27.2838 19.1 28 20 28C20.9 28 21.8 27.2838 22.7344 26.523C25.3826 24.3674 29 21.9588 29 17.4391C29 12.9195 24.0499 9.71414 20 14.0593C15.9501 9.71414 11 12.9195 11 17.4391Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 20.9V19.1C24 18.6501 23.6368 18.2857 23.1879 18.2857H21.9554C21.8201 18.2857 21.7133 18.1786 21.7133 18.0428V16.8143C21.7133 16.3642 21.3499 16 20.9012 16H19.0988C18.6501 16 18.2867 16.3642 18.2867 16.8143V18.0428C18.2867 18.1786 18.1799 18.2857 18.0446 18.2857H16.8121C16.3632 18.2857 16 18.6501 16 19.1V20.9C16 21.3501 16.3632 21.7143 16.8121 21.7143H18.0446C18.1799 21.7143 18.2867 21.8215 18.2867 21.9572V23.1857C18.2867 23.6358 18.6501 24 19.0988 24H20.9012C21.3499 24 21.7133 23.6358 21.7133 23.1857V21.9572C21.7133 21.8215 21.8201 21.7143 21.9554 21.7143H23.1879C23.6368 21.7143 24 21.3501 24 20.9Z",
    fill: "url(#paint1_linear_2101_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2101_2",
    x1: 26.1842,
    y1: 6.88544,
    x2: 14.254,
    y2: 32.1852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0013,
    stopColor: "#00CE2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06AA25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2101_2",
    x1: 18.5448,
    y1: 16.9143,
    x2: 21.352,
    y2: 22.8671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0013,
    stopColor: "#00CE2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06AA25"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgL2Tvbh, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/L2tvbh.c40ca0a7.svg";
export { ForwardRef as ReactComponent };